module.exports = __webpack_public_path__ + "img/switch-energy.e503a9a.webp";